import { BasicEmotions } from "../../../SubjectData/BasicWords/Emotions.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function BasicEmotionsDeck() {


 return (
    <>
      <HeaderNav GoBack_to="/EmotionsNav" />
      <FlashcardInterface deckData={BasicEmotions} title="Basic Emotions" />
    </>
)}